/* eslint-disable no-undef */

'use strict';

if (window.dw
    && window.dw.applepay
    && window.ApplePaySession
    && window.ApplePaySession.canMakePayments()) {
    $('body').addClass('apple-pay-enabled');
    $('.payments-digital').removeClass('d-none');
} else {
    var googleIsEnabled = $('#js-googlepay-container');
    if(googleIsEnabled.length <= 0) {
        $('.payments-digital').addClass('d-none');
    } else {
        $('.payments-digital').removeClass('d-none');
    }
}
